import { render } from "./PullToRefresh.vue?vue&type=template&id=ca3a8986&scoped=true&ts=true"
import script from "./PullToRefresh.vue?vue&type=script&lang=ts"
export * from "./PullToRefresh.vue?vue&type=script&lang=ts"

import "./PullToRefresh.vue?vue&type=style&index=0&id=ca3a8986&lang=scss&scoped=true"

import exportComponent from "/home/production/domains/monteur.waterluxe.nl/monteur-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca3a8986"]])

export default __exports__